var React = require('react');

function HeaderDropdownIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"3","rx":"1.5","fill":"#fff","key":0}),React.createElement("rect",{"y":"7","width":"20","height":"3","rx":"1.5","fill":"#fff","key":1}),React.createElement("rect",{"y":"14","width":"20","height":"3","rx":"1.5","fill":"#fff","key":2})]);
}

HeaderDropdownIcon.defaultProps = {"width":"20","height":"17","viewBox":"0 0 20 17","fill":"none"};

module.exports = HeaderDropdownIcon;

HeaderDropdownIcon.default = HeaderDropdownIcon;
